import React from "react";
import Responsive from "react-responsive";

const Desktop = props => <Responsive minWidth={1280} {...props} />;
const Tablet = props => <Responsive minWidth={768} maxWidth={991} {...props} />;
const Mobile = props => <Responsive maxWidth={767} {...props} />;
const Default = props => <Responsive minWidth={768} {...props} />;

export { Default, Tablet, Mobile, Desktop };
